class ShopifyAjaxAPI {
  static #cart;
  static #request = false;
  static #lastUpdated;
  static #ttl = 10;
  static #sections = { sections: "cart-main,cart-icon" };

  static get cart() {
    if (this.#lastUpdated + this.#ttl * 1000 > new Date().getTime()) {
      // console.log("from cache");
      this.#request = false;
      return new Promise((res) => res(this.#cart)).then((cart) => cart);
    } else {
      if (this.#request) {
        // console.log(
        //   "from live",
        //   "leverage current connection",
        //   this.#lastUpdated
        // );
        return this.#request;
      }
      // console.log("from live", "initial", this.#request);
      return this.#call;
    }
  }

  static get #call() {
    return (this.#request = fetch("/cart.js")
      .then((fn) => {
        this.#lastUpdated = new Date().getTime();
        return fn;
      })
      .then(this.#handlePromise));
  }

  static add(items) {
    return new Promise((res) => (!this.#cart ? res() : res())).then(() =>
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          items,
          ...this.#sections,
        }),
      })
        .then((d) => d.json())
        .then((cart) => {
          this.#cart = { ...this.#cart, sections: cart.sections };
          return this.#call;
        })
    );
  }

  static change(item) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ ...item, ...this.#sections }),
    }).then(this.#handlePromise);
  }

  static upsert(item) {
    return this.cart.then((cart) => {
      if (cart.items.find(({ id }) => item.variant_id === id)) {
        return this.change(item);
      } else {
        return this.add([item]);
      }
    });
  }

  static update(props) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(props),
    }).then(this.#handlePromise);
  }

  static clear() {
    return fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
    }).then(this.#handlePromise);
  }

  static get note() {
    return this.cart.then(({ note }) => note);
  }

  static set note(note) {
    this.update({
      note,
      ...this.#sections,
    });
  }

  static get(variant_id) {
    return this.cart.then(({ line_items }) =>
      line_items.find((item) => item.variant_id === variant_id)
    );
  }

  static #handlePromise(fn) {
    return fn.json().then((cart) => {
      return ShopifyAjaxAPI.#checkChanges(cart);
    });
  }

  static #checkChanges(cart) {
    // console.log(
    //   "changed items: ",
    //   JSON.stringify(cart) !== JSON.stringify(this.#cart)
    // );
    if (JSON.stringify(cart) !== JSON.stringify(this.#cart)) {
      const cartItemsDiff = this.#cart?.items && [
        ...cart.items.reduce((diff, item) => {
          const variant = this.#cart.items.find((c) => c.id === item.id);
          variant && variant.quantity !== item.quantity
            ? diff.push({
                ...variant,
                quantity: item.quantity - variant?.quantity,
              })
            : !variant
            ? diff.push(item)
            : "";
          return diff;
        }, []),
        ...this.#cart.items
          .filter((item) => !cart.items.find((c) => c.id === item.id))
          .map((item) => ({ ...item, quantity: -1 * item.quantity })),
      ];
      this.#cart = cart.sections ? cart : { ...this.#cart, ...cart };
      this.#lastUpdated = new Date().getTime();
      document.documentElement.dispatchEvent(
        new CustomEvent("cartChanged", {
          bubbles: true,
          cancelable: false,
          composed: true,
          detail: this.#cart,
        })
      );
      cartItemsDiff &&
        document.documentElement.dispatchEvent(
          new CustomEvent("cartChangedDiff", {
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: { items: cartItemsDiff, sections: this.#cart.sections },
          })
        );
    }
    return this.#cart;
  }
}
